import React, { Fragment, useState } from "react";
import Error from "./Error";
import Shortid from "shortid";
import propTypes from "prop-types";

const Formulario = ({setgastoss,setcrearGasto}) => {
  //definir state
  const [gasto, setgasto] = useState({
    nombre: "",
    cantidad: 0,
  });

  const [error, seterror] = useState(false);

  //funcion que se ejecuta cada vez que hay cambios en el formulario
  const updateGasto = (e) => {
    setgasto({
      ...gasto,
      [e.target.name]: e.target.value,
    });
  };

  const { nombre, cantidad } = gasto;

  const agregarGasto = (e) => {
    e.preventDefault();
    //validar
    if (
      nombre.trim() === "" ||
      parseInt(cantidad, 10) < 1 ||
      isNaN(parseInt(cantidad, 10))
    ) {
      seterror(true);
      return;
    }

    seterror(false);

    //construir el gasto
    const gastoConstructor = {
      nombre,
      cantidad: parseInt(cantidad, 10),
      id: Shortid(),
    };

    //pasar el gasto al componente principal
    setgastoss(gastoConstructor);
    setcrearGasto(true);

    //resetear el form
    setgasto({
        nombre: "",
        cantidad: 0,
      })


  };

  return (
    <Fragment>
      <h2>Agregar gastos aquí</h2>

      <form onSubmit={agregarGasto}>
        {error ? <Error mensaje="Formulario de gasto incorrecto" /> : null}

        <div className="campo">
          <label>Nombre del Gasto</label>
          <input
            type="text"
            name="nombre"
            placeholder="ej. Alquiler"
            className="u-full-width"
            value={nombre}
            onChange={updateGasto}
          />
        </div>
        <div className="campo">
          <label>Cantidad de Gasto</label>
          <input
            type="number"
            placeholder="ej. 300"
            className="u-full-width"
            name="cantidad"
            value={cantidad}
            onChange={updateGasto}
          />
        </div>
        <input
          type="submit"
          className="button-primary u-full-width"
          value="Agregar Gasto"
        ></input>
      </form>
    </Fragment>
  );
};

Formulario.propTypes = {
    setgastoss: propTypes.func.isRequired,
    setcrearGasto: propTypes.func.isRequired
}


export default Formulario;
